export default __webpack_public_path__ + "static/key-brain--pink-e38fe3a3613f90700fe216386fb04031.png";